<!-- @format -->

<template>
  <div>
    <!-- v-if="isWXflag" -->
    <div
      class="bgimng"
      :style="{
        background: 'url(' + configDatas.config.school_building + ') center center no-repeat'
      }"
    >
      <div class="bgbox">
        <div class="flag-img" v-if="!yishengyice && isDhShow">
          <img src="@/assets/image/transfer/haijuyingcai.png" style="height: 47px; width: 66px" alt="" />
        </div>

        <div v-if="isDhShow" class="boxtop">
          <img class="school-logo" :src="configDatas.config.school_badge" alt="" />
          <div v-if="yunNanFlag == -1" class="toptextp">
            <p class="topp1" v-show="yishengyice">{{ configDatas.school }}</p>
<!--            <p class="topp2" v-if="/esu.applyoffer.com/g.test(this.locationOrigin)">-->
<!--              2022届毕业生校园招聘平台-->
<!--            </p>-->
            <p class="topp2" v-if="yishengyice">就业育人平台</p>
            <p class="topp2" v-else>2025届高校毕业生校园招聘系列活动</p>
            <p class="topp1" v-show="!yishengyice">{{ configDatas.school }}{{configDatas.school === '河北工程大学' ? '':'站'}}</p>
          </div>
          <div v-else class="toptextp">
            <p class="topp2">云南省2022年高校毕业生</p>
            <p class="topp1">“就业冲刺”系列网络招聘活动</p>
          </div>
        </div>
        <div v-else class="boxtop">
          <img class="school-logo" :src="configDatas.config.school_badge" alt="" />
          <div class="toptextp">
            <p class="topp2">东华大学就指委理事单位</p>
            <p class="topp1">限时视频招聘会</p>
          </div>
        </div>
        <div class="boxbot">
          <div class="bitbox" @mouseenter="changeImageSrc('hover')" @mouseleave="changeImageSrc('nohover')" @click="opencompany">
            <img style="height: 56px; width: 56px" :src="imgsrc" alt="" />
            <p class="bottext" ref="image">企业入口</p>
          </div>

          <div class="bitbox" @mouseenter="changeImageSrc1('hover')" @mouseleave="changeImageSrc1('nohover')" @click="openstudent">
            <img style="height: 56px; width: 56px" :src="imgsrc1" alt="" />
            <p class="bottext" ref="image1">学生求职</p>
          </div>

          <div class="bitbox" @mouseenter="changeImageSrc2('hover')" @mouseleave="changeImageSrc2('nohover')" @click="openschool">
            <img style="height: 56px; width: 56px" :src="imgsrc2" alt="" />
            <p class="bottext" ref="image2">{{yunNanFlag != -1 ? '管理后台' : configDatas.school_type == 1 ? '高校后台' : '院系后台'}}</p>
          </div>
        </div>
        <div class="site-desc" v-if="!yishengyice">
          <p class="p1">本网站为“毕业申”为各省市政府人才工作部门开发的校园招聘平台</p>
          <p>岗位发布经严格审核后面向全国高校共享 <span v-if="configDatas.school_type == 1">，非{{ configDatas.school }}就业网</span></p>
        </div>
      </div>
    </div>

    <Modal class-name="modelcon" v-model="modal2" :closable="false" width="320">
      <div
        class="wximg"
        :style="{
          background: 'url(' + coverwximg + ') center center no-repeat'
        }"
      >
        <div class="wximgbox">
          <img style="height: 100px; width: 100px; border-radius: 50px" :src="this.configDatas.config.school_badge" alt="" />
        </div>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
      <p class="allpoi">学生求职，请用微信扫码访问</p>

      <img class="closesty" @click="closemodel" src="@/assets/image/transfer/close.png" alt="" />

      <div slot="footer"></div>
    </Modal>

    <Modal class-name="schstyle" v-model="modal3" width="522">
      <div>
        <SchloginForm :school_type="configDatas.school_type" @func1="getMsgFormSon1"  />
      </div>
      <div slot="footer"></div>
    </Modal>

    <Modal v-model="modal1" class-name="comstyle">
      <div>
        <ComloginForm @func="getMsgFormSon" :company_concat_qr_code_url="company_concat_qr_code_url" />
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import SchloginForm from '@/components/transferlogin/schoollogin.vue'
import ComloginForm from '@/components/transferlogin/companylogin2.vue'
import {  getcominfo,getschoolqrcode,getSchoolData, getsitecollege,getsitemajors } from '@/api/indexPage.js'
// import { getToken } from '@/libs/util'
import Cookies from 'js-cookie'
import {disSlide, initSlide, isStudentLogin,isSchoolLogin,isCompanyLogin,dealDefaultAvatar, setMeta} from '@/utils/utils'
export default {
  name: 'Transferlogin',
  components: {
    SchloginForm,
    ComloginForm
  },
  data () {
    return {
      school_type: '',
      company_concat_qr_code_url: '',
      yishengyice: false,
      modal1: false,
      modal2: false,
      modal3: false,
      coverImgUrl: '',
      schooltitle: '',
      schoologo: '',
      domain: '',
      coverwximg: '',
      spinShow: false,
      imgsrc: require('@/assets/image/transfer/qiye_nor.png'),
      imgsrc1: require('@/assets/image/transfer/xuesheng_nor.png'),
      imgsrc2: require('@/assets/image/transfer/houtai_nor.png'),

      browserType: '',
      locationOrigin: '',
      isWXflag: false,
      yunNanFlag: '',
      isDhShow: true,
      collegeDept: ''
    }
  },
  // props:['configData'],
  props: {
    configDatas: {
        type: Object
    }
  },
  created () {
    this.getcominfo()

    console.log('configDatas=======',this.configDatas)
    // if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)) {
    //   this.isWXflag = false

    // } else {
    //   this.isWXflag = true
    // }
    this.locationOrigin = window.location.origin
    this.browserTypeis()
    this.isDhShow = location.host.indexOf('dhu.applyoffer.com') === -1
    // console.log('===========', this.isDhShow)
    let yishengyice = location.host.indexOf('jiuyeyuren.com')
    // this.yunNanFlag = location.host.indexOf('yunnan.applyoffer.com')
    this.yunNanFlag = location.host.indexOf('yunnan.applyoffer.com')
    sessionStorage.setItem('yunnan', this.yunNanFlag)
    // console.log('this.yunNanFlag', this.yunNanFlag)
    this.yishengyice = yishengyice !== -1
    // console.log('=====', this.yishengyice)
    sessionStorage.setItem('yishengyice', yishengyice === -1 ? 0 : 1)
    this.domain = window.location.origin.split('//')[1]
    this.getindexdata()
    if(this.configDatas && this.configDatas.school_type == 1) {
      console.log('获取院系列表');
      // 学校
      this.getsitecollege()
    }else{
      console.log('获取专业列表');
      // 院系
      this.getsitemajors()
    }
  },

  methods: {
    // 获取站点下属院系
    async getsitecollege() {
      console.log('获取站点下属院系');
      const schoolName = this.configDatas.school
      const metaMap = {
        title: `${schoolName}校园招聘平台，本校学生一键求职，专属职位推荐`,
        keyWord: `${schoolName}校园招聘平台,${schoolName},校招平台,校园招聘会,校招,求职,招聘`,
        desc: `${schoolName}校园招聘平台。本校学生一键求职，专属职位推荐。用人单位登录注册。`
      }
      const res = await getsitecollege({domain: this.domain})
      if(res) {
        this.collegeDept = res.college
        metaMap.desc =  `${schoolName}校园招聘平台。本校学生一键求职，专属职位推荐。用人单位登录注册。${this.collegeDept}`
      }
      setMeta(...Object.values(metaMap))
    },
      // 获取站点下属专业、
    async getsitemajors() {
      console.log('获取站点下属专业');
      const { school, college } = this.configDatas
      const metaMap = {
        title: `${school}${college}校园招聘平台，本校学生一键求职，专属职位推荐`,
        keyWord: `${school}${college}校园招聘平台,${school},${college},校招平台,校园招聘会,校招,求职,招聘`,
        desc: `${school}${college}校园招聘平台。本校学生一键求职，专属职位推荐。用人单位登录注册。`
      }
      const res = await getsitemajors({domain: this.domain})
      if(res) {
        this.majors = res.majors
        metaMap.desc = `${school}${college}校园招聘平台。本校学生一键求职，专属职位推荐。用人单位登录注册。${this.majors}`
      }
      setMeta(...Object.values(metaMap))
  },
    getcominfo () {
      console.log()
      let data = {
        domain: location.host
      }
      getcominfo(data).then(res => {
        // console.log('res===========',res)
        if (res.apiStatus) {
          this.company_concat_qr_code_url = res.company_concat_qr_code_url
        }
      })
    },
    browserTypeis () {
      let userAgentstr = navigator.userAgent.toLocaleLowerCase()
      if (/safari/.test(userAgentstr) && !/chrome/.test(userAgentstr)) {
        this.browserType = 'Safari'
      } else if (userAgentstr.match(/tencenttraveler/) != null || userAgentstr.match(/qqbrowse/) != null) {
        this.browserType = 'QQ'
      } else if (userAgentstr.match(/msie/) != null || userAgentstr.match(/trident/) != null) {
        this.browserType = 'IE'
      } else if (userAgentstr.indexOf('firefox') > -1) {
        // 判断是否Firefox浏览器
        this.browserType = 'Firefox'
      }
    },
    getMsgFormSon (data) {
      this.modal1 = data
    },

    getMsgFormSon1 (data) {
      this.modal3 = data
    },
    goindexpro () {
      window.open(`https://biyeshen.cn/`)
    },

    async getindexdata () {
      const res = await getSchoolData({ domain: this.domain })
      console.log('res=======',res)
      if (!res.apiStatus) return this.$Message.error(this.data.msg)
      const schoolInfo = res.qr_parameter_id
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)) {
        let domain = this.yishengyice ? `yishengyice` : 'applyoffer'
        let page = ''
        if(this.configDatas.is_show_jobfair == 0){
          console.log('关闭按钮')
          return
        }else{

          if (this.yishengyice) page = '&page=position_list'
          window.location.href = `http://wxjump.${domain}.com/#/?scene=${schoolInfo}${page}`
        }
      } else {
        // schoolInfo.config.school = schoolInfo.school
        // schoolInfo.config.school_type = schoolInfo.school_type
        // sessionStorage.setItem('schoolconfig', JSON.stringify(schoolInfo.config))
        // this.coverImgUrl = schoolInfo.config.school_building
        // this.schoologo = schoolInfo.config.school_badge

        // this.schooltitle = schoolInfo.school
        // this.school_type = +schoolInfo.school_type
      }
    },

    opencompany () {
      if (isCompanyLogin()) {
        if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
          window.location.href = `${window.location.origin}/company/#/`
        } else {
          window.open(`${window.location.origin}/company/#/`)
        }
        // window.open(`${window.location.origin}/company/#/`);
        // window.open(`http://company.dev.applyoffer.com:8081/`);
        // window.open(`https://qiye.biyeshen.cn/#/`)
        // window.open(`http://company.daily.applyoffer.com/`)
      } else {
        this.modal1 = true
      }
    },

    openschool () {
      // const token = getToken()
      // if (token) {
      //   if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
      //     window.location.href = `${window.location.origin}#/dashboard`
      //   } else {
      //     window.open(`${window.location.origin}#/dashboard`)
      //   }
      // } else {
      //   this.modal3 = true
      // }
      if (isSchoolLogin()) {
          if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
            window.location.href = `${window.location.origin}/school/#/dashboard`
          } else {
            window.open(`${window.location.origin}/school/#/dashboard`)
          }
        } else {
          this.modal3 = true
          disSlide()
        }
    },
    closemodel () {
      this.modal2 = false
    },
    openstudent () {
      this.modal2 = true
      this.spinShow = true

      getschoolqrcode().then(res => {
        // console.log('data-res',res)
        if (res.apiStatus) {
          this.coverwximg = res.QRcode
          this.spinShow = false
        }
      })
    },

    changeImageSrc (key) {
      switch (key) {
        case 'hover':
          this.imgsrc = require('@/assets/image/transfer/qiye_sel.png')
          this.$refs.image.style.color = '#3B80FB'
          break
        case 'nohover':
          this.imgsrc = require('@/assets/image/transfer/qiye_nor.png')
          this.$refs.image.style.color = '#666'
          break
      }
    },

    changeImageSrc1 (key) {
      switch (key) {
        case 'hover':
          this.imgsrc1 = require('@/assets/image/transfer/xuesheng_sel.png')
          this.$refs.image1.style.color = '#3B80FB'
          break
        case 'nohover':
          this.imgsrc1 = require('@/assets/image/transfer/xuesheng_nor.png')
          this.$refs.image1.style.color = '#666'
          break
      }
    },

    changeImageSrc2 (key) {
      switch (key) {
        case 'hover':
          this.imgsrc2 = require('@/assets/image/transfer/houtai_sel.png')
          this.$refs.image2.style.color = '#3B80FB'
          break
        case 'nohover':
          this.imgsrc2 = require('@/assets/image/transfer/houtai_nor.png')
          this.$refs.image2.style.color = '#666'
          break
      }
    }
  }
}
</script>

<style scoped lang="less">
.bgimng {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  /* background: url(../../assets/images/bgtestimg.png) center center no-repeat; */
  background-size: cover !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bgbox {
  position: relative;
  height: 495px;
  width: 880px;
  border-radius: 8px;
  padding: 0 40px;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  .boxtop {
    height: 192px;
    width: 100%;
    border-radius: 16px 16px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .school-logo {
      height: 80px;
      width: 80px;
      border-radius: 50%;
    }
    .toptextp {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      .topp1 {
        font-size: 28px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #ffffff;
      }

      .topp2 {
        font-size: 24px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
      }
    }
  }
  .flag-img {
    height: 47px;
    width: 66px;
    position: absolute;
    top: 32px;
    left: 40px;
  }
  .boxbot {
    margin: 0 auto;
    width: 735px;
    display: flex;
    justify-content: space-around;
    .bitbox {
      width: 225px;
      height: 150px;
      background: #fff;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &:hover {
        background: #f0f6ff;
        box-shadow: 0px 5px 15px 0px #0f316e;
        transition: all 0.8s;
        cursor: pointer;
      }
      .bottext {
        margin-top: 16px;
        font-size: 18px;
        font-family: MicrosoftYaHei;
        color: #666666;
      }
    }
  }
  .site-desc {
    .p1 {
      text-align: center;
      margin-bottom: 3px;
    }
    margin: 48px auto 0;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
  }
}

.botp {
  margin-top: 30px;
  font-size: 14px;
  color: #eeeeee;
  display: flex;
  justify-content: center;
}

.allpoi {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #ffffff;
  margin: 10px 0 10px 0;
}

.footmodp {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: #666666;
  cursor: pointer;
  text-decoration: underline;
}

.closesty {
  height: 45px;
  width: 24px;
  position: absolute;
  top: -34px;
  right: 0;
  z-index: -1;
  cursor: pointer;
}

.wximg {
  height: 304px;
  width: 284px;
  // border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px !important;
  background-size: 100% 100% !important;
  /* position: relative; */
}

.wximgbox {
  /* position: absolute; */
  height: 110px;
  width: 110px;
  background: #fff;
  border-radius: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* top:20px; */
}
</style>

<style>
.modelcon .ivu-modal-body {
  background: #3b80fb;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 368px !important;
  border-radius: 6px !important;
  /* border-radius: 6px 6px 0px 0px; */
}

.modelcon .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modelcon .ivu-modal-footer {
  padding: 0 !important;
  border: 0 !important;
}
.schstyle .ivu-modal-footer {
  padding: 0 !important;
  border: 0 !important;
}
.comstyle .ivu-modal-footer {
  padding: 0 !important;
  border: 0 !important;
}
.comstyle .ivu-modal-body {
  padding: 0 !important;
  border: 0 !important;
}

.schstyle .ivu-modal-body {
  padding: 0 !important;
  height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/transferlogin/transferlogin.vue